import React from 'react';
import * as S from './style';

import { Label } from 'components';

export const createArray = (lastStep: number) => {
  let result = new Array<number>();
  for (let i = 1; i <= lastStep; i++) {
    result.push(i);
  }
  return result;
};
export interface Props {
  lastStep: number;
  currentStep: number;
  currentStepName: string;
}

function StepNavigation({ lastStep, currentStep, currentStepName }: Props) {
  return (
    <S.StepNavigation>
      {createArray(lastStep).map((item, index) => {
        if (item === currentStep) {
          return (
            <S.CurrentContainer key={index}>
              <S.CurrentStepNumber>
                <Label contents={item} color={'gray_opacity_50'} />
              </S.CurrentStepNumber>
              <S.CurrentStepName>
                <Label
                  color={'blue_900'}
                  contents={currentStepName}
                  wordBreak={true}
                />
              </S.CurrentStepName>
            </S.CurrentContainer>
          );
        } else {
          return (
            <S.StepNavNumber key={index}>
              <Label contents={item} color={'gray_opacity_50'} />
            </S.StepNavNumber>
          );
        }
      })}
    </S.StepNavigation>
  );
}

export default StepNavigation;
